import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import { BaseExternalResource } from '/@/modules/core/app/resources/BaseExternalResource';

export class BaseExternalResourceService extends BaseService {
  /**
   * @var {BaseExternalResource}
   */
  resource;

  constructor() {
    super();

    this.resource = new BaseExternalResource();
  }
}
